import * as React from 'react';
import {
    BodyMediumRegular,
    BodySmallEmphasized,
    LabelRegular,
    Private,
    XStack,
    YStack,
} from 'smoothie';

import {
    centsToDollars,
    formatDollars,
} from '../../../common/utils/bankingUtils';
import {
    format,
    SHORT_READABLE_DATE_FORMAT,
} from '../../../common/utils/dateUtils';
import { type Transaction } from '../../types/HolisticSummary';

const TransactionsList = ({
    transactions,
}: {
    transactions: Transaction[];
}) => {
    return (
        <YStack flex={1}>
            <YStack justifyContent="space-between" paddingRight={16}></YStack>
            <YStack paddingBottom={8}>
                {transactions
                    .filter((a: Transaction) => {
                        return !a.pending;
                    })
                    .sort((a: Transaction, b: Transaction) => {
                        return (
                            new Date(b.date).getTime() -
                            new Date(a.date).getTime()
                        );
                    })
                    .map((transaction: Transaction) => {
                        return (
                            <HolisticTransaction
                                key={transaction.id}
                                transaction={transaction}
                            />
                        );
                    })}
            </YStack>
        </YStack>
    );
};

const HolisticTransaction = ({ transaction }: { transaction: Transaction }) => {
    return (
        <XStack
            marginVertical={8}
            justifyContent="space-between"
            borderTopWidth={1}
            borderTopColor="$gray200"
            gap={8}
        >
            <YStack paddingTop={8} paddingLeft={8} flex={3}>
                <Private>
                    <BodySmallEmphasized
                        numberOfLines={1}
                        ellipsizeMode="tail"
                        color="$black"
                    >
                        {transaction.description}
                    </BodySmallEmphasized>
                </Private>
                <LabelRegular color="$gray1000">
                    {format(transaction.date, SHORT_READABLE_DATE_FORMAT)}
                </LabelRegular>
            </YStack>
            <YStack
                alignItems="flex-end"
                paddingTop={8}
                paddingRight={4}
                flex={1}
            >
                <Private>
                    <BodyMediumRegular color="$black">
                        {transaction.type === 'debit' ? '-' : ''}
                        {formatDollars(
                            centsToDollars(transaction.amount),
                            true,
                        )}
                    </BodyMediumRegular>
                </Private>
                <LabelRegular color="$gray1000">
                    {transaction.pending ? '(pending)' : ''}
                </LabelRegular>
            </YStack>
        </XStack>
    );
};

export default TransactionsList;
